import { ClockIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { CopyField } from '@/components/data-display/CopyField';
import { EmptyState } from '@/components/feedback/EmptyState';
import { PageMeta } from '@/components/layout/PageMeta';
import { PaymentSummary } from '@/components/layout/PaymentSummary';
import { ReturnHomeButton } from '@/components/layout/ReturnHomeButton';
import { Stack } from '@/components/layout/Stack';
import { SupportContacts } from '@/components/layout/SupportContacts';
import { useFunnelScreen } from '@/hooks/useFunnelScreen';

export function ExpiredPage() {
  const { t } = useTranslation('outcome');
  const { t: tCommon } = useTranslation('common');
  const { deposit, summary, support, returnUrl, goHomeLabel } = useFunnelScreen();
  const providerReference = deposit?.providerReference ?? null;
  const reviewLapsed = providerReference !== null;

  const title = reviewLapsed ? t('expired.reviewLapsed.title') : t('expired.title');

  return (
    <Stack gap="lg">
      <PageMeta title={title} />
      {summary !== null && <PaymentSummary {...summary} />}
      <EmptyState
        icon={<ClockIcon />}
        tone="warning"
        title={title}
        body={reviewLapsed ? t('expired.reviewLapsed.body') : t('expired.body')}
      >
        <p className="text-text-muted max-w-prose text-sm leading-relaxed">
          {reviewLapsed ? t('expired.reviewLapsed.doNotPayAgain') : t('expired.moneyQuestion')}
        </p>
        <p className="text-text-muted max-w-prose text-sm leading-relaxed">
          {reviewLapsed ? t('expired.reviewLapsed.next') : t('expired.next')}
        </p>
        {reviewLapsed && (
          <div className="w-full max-w-sm text-start">
            <CopyField
              label={t('expired.reviewLapsed.providerReferenceLabel')}
              value={providerReference}
              copyLabel={tCommon('actions.copy')}
              copiedLabel={tCommon('actions.copied')}
              manualCopyLabel={tCommon('actions.manualCopy')}
              monospace
            />
          </div>
        )}
      </EmptyState>
      <SupportContacts {...support} />
      <ReturnHomeButton href={returnUrl} label={goHomeLabel} />
    </Stack>
  );
}
